import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Response_HHInformation } from '../../../../../constants/APIs';

export default class HolidayHomesInformation extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Response_HHInformation} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
